module.exports = __webpack_public_path__ + "img/star3.61694495.png";